// extracted by mini-css-extract-plugin
export default {"searchResult":"searchResult_searchResult__K6nb8","pagination":"searchResult_pagination__HfQJv","paginationBtn":"searchResult_paginationBtn__dzoUx"};